"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientLanding = void 0;
const react_1 = __importStar(require("react"));
const PatientLanding_elements_1 = require("./PatientLanding.elements");
const heart_svg_1 = __importDefault(require("@components/icons/landing/heart.svg"));
const galochka_svg_1 = __importDefault(require("@components/icons/landing/galochka.svg"));
const video_and_pic_svg_1 = __importDefault(require("@components/icons/landing/video-and-pic.svg"));
const notesboard_svg_1 = __importDefault(require("@components/icons/landing/notesboard.svg"));
const speech_cloud_svg_1 = __importDefault(require("@components/icons/landing/speech-cloud.svg"));
const talk_webp_1 = __importDefault(require("@images/landing/patient/talk.webp"));
const Landing_1 = require("@app/routes/Landing");
const PatientLanding_translations_1 = require("./PatientLanding.translations");
const PatientLanding = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = PatientLanding_translations_1.translations[language];
    return (react_1.default.createElement(PatientLanding_elements_1.PatientLandingWrap, null,
        react_1.default.createElement("h1", null, t.h1),
        react_1.default.createElement("div", { className: "landing-patient-main-content" },
            react_1.default.createElement(PatientLanding_elements_1.Container, { style: { color: "#7B4EF8" }, className: "landing-patient-1" },
                react_1.default.createElement("p", null, t.mainContent["1"].p)),
            react_1.default.createElement("div", { className: "landing-patient-row" },
                react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-2" },
                    react_1.default.createElement(galochka_svg_1.default, null),
                    react_1.default.createElement("div", { className: "landing-patient-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["2"].h3),
                        react_1.default.createElement("p", null, t.mainContent["2"].p))),
                react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-3" },
                    react_1.default.createElement(notesboard_svg_1.default, null),
                    react_1.default.createElement("div", { className: "landing-patient-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["3"].h3),
                        react_1.default.createElement("p", null, t.mainContent["3"].p)))),
            react_1.default.createElement("div", { className: "landing-patient-row" },
                react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-4" },
                    react_1.default.createElement(video_and_pic_svg_1.default, null),
                    react_1.default.createElement("div", { className: "landing-patient-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["4"].h3),
                        react_1.default.createElement("p", null, t.mainContent["4"].p))),
                react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-5" },
                    react_1.default.createElement(speech_cloud_svg_1.default, null),
                    react_1.default.createElement("div", { className: "landing-patient-container-info" },
                        react_1.default.createElement("h3", null, t.mainContent["5"].h3),
                        react_1.default.createElement("p", null, t.mainContent["5"].p)))),
            react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-6" },
                react_1.default.createElement(heart_svg_1.default, null),
                react_1.default.createElement("div", { className: "landing-patient-container-info" },
                    react_1.default.createElement("h3", null, t.mainContent["6"].h3),
                    react_1.default.createElement("p", null, t.mainContent["6"].p)))),
        react_1.default.createElement(PatientLanding_elements_1.Container, { className: "landing-patient-chat" },
            react_1.default.createElement("img", { src: talk_webp_1.default, alt: "" }),
            react_1.default.createElement("p", null, t.chat))));
};
exports.PatientLanding = PatientLanding;
